// This plugin MUST run before auth0.ts to capture the original URL
// before Auth0 redirects strip the query parameters.
// The "000-" prefix ensures it loads first alphabetically.

import { savePostLoginRedirect } from '~/composables/usePostLoginRedirect';

export default defineNuxtPlugin(() => {
  const pathname = window.location.pathname;
  const search = window.location.search;

  // Skip Auth0 callback URLs - they have code= and state= params
  // and should not overwrite the intended destination
  if (search.includes('code=') && search.includes('state=')) {
    return;
  }

  const fullPath = pathname + search;

  // On initial page load, force save the URL the user actually visited
  // This ensures deep links work correctly
  savePostLoginRedirect(fullPath, { force: true, source: '000-save-initial-url' });
});
